import { Components, Theme } from '../../material';
import { borderRadius } from '../tokens';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  defaultProps: {
    slotProps: {
      paper: {
        elevation: 6,
      },
    },
  },
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: borderRadius.abs(theme.shape.borderRadius, 's'),
    }),
  },
};
